import React from 'react';

const INK = '#333';
const MUTED = '#888';
const FILL = '#e4e4e4';

const Person = ({ x, y, s = 1, color = INK, filled = false }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    <circle cx="0" cy="-9" r="5" fill={filled ? color : 'none'} stroke={color} strokeWidth="1.6" />
    <path d="M -8 8 Q -8 -2 0 -2 Q 8 -2 8 8 Z" fill={filled ? color : 'none'} stroke={color} strokeWidth="1.6" />
  </g>
);

const Illustration = ({ caption, children, viewBox }) => (
  <figure className="v3-illustration" style={{ margin: 0 }}>
    <svg viewBox={viewBox} role="img" aria-label={caption} xmlns="http://www.w3.org/2000/svg">
      {children}
    </svg>
    <figcaption>{caption}</figcaption>
  </figure>
);

/* जातीय समीकरण — the village split into rigid caste blocks */
export const CasteEquationVisual = ({ caption }) => (
  <Illustration caption={caption} viewBox="0 0 200 90">
    <rect x="8" y="12" width="52" height="66" fill={FILL} stroke={MUTED} />
    <rect x="74" y="12" width="52" height="66" fill="none" stroke={MUTED} />
    <rect x="140" y="12" width="52" height="66" fill={FILL} stroke={MUTED} />
    <Person x="26" y="38" /><Person x="44" y="38" /><Person x="35" y="62" />
    <Person x="92" y="38" /><Person x="110" y="38" /><Person x="101" y="62" />
    <Person x="158" y="38" /><Person x="176" y="38" /><Person x="167" y="62" />
    <line x1="63" y1="12" x2="63" y2="78" stroke={INK} strokeWidth="2" strokeDasharray="4 3" />
    <line x1="130" y1="12" x2="130" y2="78" stroke={INK} strokeWidth="2" strokeDasharray="4 3" />
  </Illustration>
);

/* पार्टी का दबदबा — one giant party flag towering over small voters */
export const PartyDominanceVisual = ({ caption }) => (
  <Illustration caption={caption} viewBox="0 0 200 90">
    <line x1="58" y1="8" x2="58" y2="82" stroke={INK} strokeWidth="3" />
    <path d="M 58 10 L 118 20 L 58 34 Z" fill={INK} />
    <Person x="90" y="72" s="0.8" color={MUTED} />
    <Person x="110" y="74" s="0.7" color={MUTED} />
    <Person x="128" y="72" s="0.8" color={MUTED} />
    <Person x="147" y="74" s="0.7" color={MUTED} />
    <Person x="165" y="72" s="0.8" color={MUTED} />
    <line x1="10" y1="82" x2="190" y2="82" stroke={MUTED} strokeWidth="1.5" />
  </Illustration>
);

/* पैसों का खेल — notes changing hands over the ballot box */
export const MoneyGameVisual = ({ caption }) => (
  <Illustration caption={caption} viewBox="0 0 200 90">
    <rect x="72" y="46" width="56" height="34" fill="none" stroke={INK} strokeWidth="2" />
    <rect x="92" y="40" width="16" height="6" fill={INK} />
    <rect x="20" y="14" width="34" height="18" fill={FILL} stroke={INK} strokeWidth="1.6" transform="rotate(-12 37 23)" />
    <text x="37" y="27" fontSize="11" fontFamily="Arial, sans-serif" fill={INK} textAnchor="middle" transform="rotate(-12 37 23)">₹</text>
    <rect x="146" y="12" width="34" height="18" fill={FILL} stroke={INK} strokeWidth="1.6" transform="rotate(10 163 21)" />
    <text x="163" y="26" fontSize="11" fontFamily="Arial, sans-serif" fill={INK} textAnchor="middle" transform="rotate(10 163 21)">₹</text>
    <path d="M 52 30 Q 76 42 90 44" fill="none" stroke={MUTED} strokeWidth="1.5" strokeDasharray="3 3" />
    <path d="M 148 28 Q 124 40 110 44" fill="none" stroke={MUTED} strokeWidth="1.5" strokeDasharray="3 3" />
  </Illustration>
);

/* हज़ारों काबिल युवा — rows of educated youth, one raising a hand */
export const YouthTalentVisual = ({ caption }) => (
  <Illustration caption={caption} viewBox="0 0 200 100">
    {[0, 1, 2].map((row) =>
      [0, 1, 2, 3, 4, 5].map((col) => (
        <Person
          key={`${row}-${col}`}
          x={28 + col * 29}
          y={26 + row * 28}
          s="0.85"
          color={row === 1 && col === 2 ? INK : MUTED}
          filled={row === 1 && col === 2}
        />
      ))
    )}
    <path d="M 78 42 L 90 34 M 90 34 L 86 34 M 90 34 L 90 38" fill="none" stroke={INK} strokeWidth="1.6" />
  </Illustration>
);
